import React from "react";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import IconButton from "@material-ui/core/IconButton";
import styles from "./generatepdf.module.css";
import alderLogo from "../../../assets/img/alder-logo.png";
import { Tooltip } from "@material-ui/core";
import { renderToString } from "react-dom/server";
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import jsPDF from "jspdf";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));
const GeneratePdf = (props) => {
  const classes = useStyles();
  console.log("Generate PDF Page");
  const [pdfDialog, setPdfDialog] = React.useState(false);
  const print = () => {
    const divToDisplay = document.getElementById('pdf-div');
    // html2pdf(divToDisplay);
    let filename = `order-invoice-${props.order.order_barcode}.pdf`;
    var opt = {
      filename:     filename,
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    
    // New Promise-based usage:
    html2pdf().set(opt).from(divToDisplay).save();
    
    // Old monolithic-style usage:
    html2pdf(divToDisplay, opt);
  }
  const dprint = () => {
    const divToDisplay = document.getElementById('pdf-div');
    html2canvas(divToDisplay,{
      allowTaint:true,
      scrollY: -window.scrollY}).then(
      // onrendered:
      function(canvas) {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        console.log('on rendered');
        //One page pdf shows the canvas height generated by html pages.
        var pageHeight = contentWidth / 1200 * 1000;
        //html page height without pdf generation
        var leftHeight = contentHeight;
        //Page offset
        var position = 0;
        //a4 paper size [595.28, 841.89], html page generated canvas in pdf picture width
        var imgWidth = 1300;
        var imgHeight = 1000/contentWidth * contentHeight;
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        var pdf = new jsPDF('p', 'pt', 'a4');
        //There are two heights to distinguish, one is the actual height of the html page, and the page height of the generated pdf (841.89)
        //When the content does not exceed the range of pdf page display, there is no need to paginate
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, 'JPEG', 20, 0, imgWidth, imgHeight );
        } else {
            while(leftHeight > 0) {
                pdf.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight)
                leftHeight -= pageHeight;
                position -= 1000;
                //Avoid adding blank pages
                if(leftHeight > 0) {
                  pdf.addPage();
                }
            }
          }
          let filename = `order-invoice-${props.order.order_barcode}.pdf`;
          pdf.save(filename);
        // }
    });
  };
  const oriprint = () => {
    console.log('print data');
    const divToDisplay = document.getElementById('pdf-div');
    var HTML_Width = document.getElementById('pdf-div').offsetWidth;
    var HTML_Height = document.getElementById('pdf-div').offsetHeight;
    console.log(divToDisplay); 
    html2canvas(divToDisplay,{allowTaint:true,scrollY: -window.scrollY}).then(function(canvas) {
      
        var top_left_margin = 15;
        var PDF_Width = (HTML_Width)+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        // var PDF_Height = (HTML_Height)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        // var totalPDFPages = 1;
        // canvas_image_height = canvas.height * PDF_Width / canvas.width;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);    
        console.log('Before loop');
        console.log(PDF_Width, PDF_Height);
        console.log(top_left_margin, top_left_margin,canvas_image_width,canvas_image_height); 
        for (var i = 1; i <= totalPDFPages; i++) {
            console.log('In loop'); 
            pdf.addPage([PDF_Width, PDF_Height],'p');
            pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
            // pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);
        }
        let filename = `order-invoice-${props.order.order_barcode}.pdf`;
        pdf.save(filename);
    });
  };
    let totalAmount = 0;
    let products = [];
    let pushedObjects = [];
    let orderToDetails =
    props.order.orderType == "sales"
      ? props.order.partner
      : props.order.warehouse;
    let orderToName = orderToDetails?.name;
    let orderAddress = props.order.deliveryAddress;
    let orderToId = props.order.orderType == "sales" ? orderToDetails?.partner_barcode:orderToDetails?.warehouse_barcode;
    let totalGrossWeight = 0;
    let totalPkg = 0;
    let totalOrderQty = 0;
    let orderDate = props.order.orderDate;
    let datearray = orderDate.split("-");
    let newDate = datearray[2] + '-' + datearray[1] + '-' + datearray[0];
    orderDate = newDate;
    let orderBarcode = props.order.order_barcode;
    orderBarcode = orderBarcode != "" ? orderBarcode.toString() : "";
    // let orderItems = [];
    // orderItems = [...props.order.allLoad];
    let orderItems = props.order.allLoad.map((item) => {
      return { ...item };
    });
    console.table(orderItems);
    orderItems.forEach((val) => {
      if (val.quantity > 1) {
        // this is just a temporary solution
        // for the issue of automatically change of quantity value in props.order.allLoad
        console.log("excel val.quantity");
        console.log(val.quantity);
        val.quantity = 1;
        console.log(val.quantity);
      }
      let temp =
        val.price * val.quantity +
        (val.tax.gst / 100) * val.price * val.quantity;
        temp = Math.ceil(temp);
      totalAmount += temp - (temp / 100) * val.discount;
      let productId = val.item._id;
      console.log("productId exist:" + productId);
      if (pushedObjects.length > 0 && pushedObjects.includes(productId)) {
        console.log("id exist");
        var productIndex = products.findIndex(function (value) {
          return value.item._id == productId;
        });
        console.log(products);
        console.log("product index:" + productIndex);
        let currentQuantity = 0;
        currentQuantity = products[productIndex].quantity;
        console.log("product index quantity:" + currentQuantity);
        products[productIndex].quantity = currentQuantity + 1;
        console.log(
          "product index after quantity:" + products[productIndex].quantity
        );
      } else {
        console.log("id not exist");
        pushedObjects.push(productId);
        products.push(val);
      }
    });
    totalAmount = Math.ceil(totalAmount);
    console.table(products);
    console.log(pushedObjects);
    return (
      <React.Fragment>
        <div className={styles.downloaddiv}>
            <Button
              onClick={print}
              variant="contained"
              color="default"
              className={classes.button}
              startIcon={<GetAppRoundedIcon />}
            >
            Download
            </Button>
        </div>
        <div id="pdf-div" className={styles.container}>
          <div className={styles.content}>
            <div className={styles.header}>
              <img src={alderLogo} alt="alder logo" />
              <div className={styles.contentright} style={{ textAlign: "right"}}>
                <p><br></br>
                ALDER FURNITURE PVT LTD<br></br>
                27 FURNITURE BLOCK, KIRTI NAGAR, NEW DELHI – 110015 (INDIA)<br></br>
                Website: www.alder.in, Email: info@alder.in | sales@alder.in<br></br>
                Phone: +91-011-42903322
                </p>
              </div>
            </div>
            <div className={styles.center}>
              <p>PROFORMA INVOICE</p>
            </div>

            <div className={styles.divider}>
              <p>CLIENT&nbsp;ID:&nbsp;{orderToId}</p>
              <p>PI&nbsp;No.&nbsp;{"PI/"+(orderBarcode.substr(orderBarcode.length -5)) + ""}</p>
            </div>
            <div className={styles.divider}>
              <p>CLIENT&nbsp;NAME:&nbsp;<span className={styles.clientName}>{orderToName}</span></p>
              <p>DISPATCH&nbsp;DATE:&nbsp;{orderDate}</p>
            </div>
            <div className={styles.divider}>
              <p>CLIENT&nbsp;ADDRESS:&nbsp;{orderAddress}</p>
            </div>
            <div className={styles.divider}>
              <p></p>
            </div>
            <table className={styles.table} border="1">
              <tr className={styles.tableHeader}>
                <th>Sl No</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Order Qty</th>
                <th>Packages (parts)</th>
                <th>Total pkg</th>
                <th>Total weight</th>
                {/* <th>Total CBM</th> */}
                <th>Unit Price(INR)</th>
                <th>Discount(%)</th>
                <th>Tax(%)</th>
                <th>Total Amount(INR)</th>
              </tr>
              {products.map((val, index) => {
                let totalWeight = 0;
                let totalCBM = 0;
                val.type == "Product" &&
                  val.item &&
                  val.item.productParts.map((part) => {
                    totalWeight += parseInt(part.partId && part.partId.weight);
                    totalCBM +=
                      part.partId &&
                      part.partId.height * part.partId &&
                      part.partId.width * part.partId &&
                      part.partId.length;
                  });
                let totalAmount =
                  val.price * val.quantity +
                  (val.tax.gst / 100) * val.price * val.quantity;
                let totalAmountDis =
                  totalAmount - (totalAmount / 100) * val.discount;
                  totalAmountDis = Math.ceil(totalAmountDis);
                  totalGrossWeight += totalWeight > 0 ? (totalWeight * val.quantity):0;
                totalOrderQty += val.quantity;
                totalPkg += val.type== "Product" && val.item  ?
                val.item.productParts.length*val.quantity:1*val.quantity;
                return (
                  <React.Fragment>
                    {val.type == "Product" && val.item && val.item != null ? (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{val.item && val.item.product_barcode}</td>
                        <td className={styles.itemName} style={{ textAlign: "left"}}>{val.item && val.item.productName}</td>
                        <td>{val.quantity}</td>
                        <td>{val.item && val.item.productParts.length}</td>
                        <td>
                          {val.item &&
                            val.item.productParts.length * val.quantity}
                        </td>
                        <td>
                          {totalWeight > 0 ? totalWeight * val.quantity : ""}
                        </td>
                        {/* <td>{totalCBM > 0 ? totalCBM * val.quantity : ""}</td> */}
                        <td>{val.price}</td>
                        <td>{val.discount} %</td>
                        <td>{val.tax.gst}%</td>
                        <td>{totalAmountDis}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{val.item && val.item.parts_barcode}</td>
                        <td className={styles.itemName} style={{ textAlign: "left"}}>{val.item && val.item.partName}</td>
                        <td>{val.quantity}</td>
                        <td>1</td>
                        <td>{val.quantity}</td>
                        <td>
                          {val.item && val.item.weight > 0
                            ? val.item.weight * val.quantity
                            : ""}
                        </td>
                        {/* <td>
                          {val.item &&
                          val.item.height * val.item.width * val.item.length > 0
                            ? val.item.height *
                              val.item.width *
                              val.item.length *
                              val.quantity
                            : ""}
                        </td> */}
                        <td>{val.price}</td>
                        <td>{val.discount} %</td>
                        <td>{val.tax.gst} %</td>
                        <td>{totalAmountDis}</td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
              <tr className={styles.footerRow}>
                <th colSpan="3" className={styles.footer}>
                  Total Qty
                </th>
                <th colSpan="1" className={styles.footer}>
                  {totalOrderQty}
                </th>
                <th colSpan="1" className={styles.footer}>
                </th>
                <th colSpan="1" className={styles.footer}>
                  {totalPkg}
                </th>
                <th colSpan="1" className={styles.footer}>
                  {totalGrossWeight}
                </th>
                <th colSpan="3" className={styles.footer}>
                  Total Amount
                </th>
                <th colSpan="1" className={styles.footer}>
                  Rs {totalAmount}
                </th>
              </tr>
            </table>
          </div>
        </div>
      </React.Fragment>
    );
};
export default GeneratePdf;
